export var ServiceType;
(function (ServiceType) {
    ServiceType["Users"] = "users";
    ServiceType["Messages"] = "messages";
    ServiceType["Events"] = "events";
})(ServiceType || (ServiceType = {}));
